exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-2b57f6a2] .gridcard div.parent .v-card {\n  display: none !important;\n}\n[data-v-2b57f6a2] .ag-root-wrapper-body.ag-layout-normal {\n  height: auto !important;\n}\n.idCard[data-v-2b57f6a2] {\n  height: 100%;\n  max-height: 100%;\n}\n.idcardTitle[data-v-2b57f6a2] {\n  font-size: medium;\n  width: 100%;\n  max-height: 54px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.titleCards[data-v-2b57f6a2] {\n  padding: 17px;\n  font-weight: 500;\n}\n", ""]);

// exports
